import Vue from 'vue';
import Router from 'vue-router';
/* Layout */
import Layout from '@/platform/index.vue';
import searchPlatform from '@/platform/Platform.vue';
import RNPLayout from '@/platform/RNPLayout.vue';
import VcardLayout from '@/platform/VcardLayout.vue';
import gdnaturalLayout from '@/platform/gdnaturalLayout.vue';
import i18n from '@/lang';
import storage from './sdk/common/Storage';
import store from './store';
Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('@/views/home.vue')
        },
        {
          path: 'admin',
          name: 'admin',
          component: () => import('@/views/admin.vue')
        },
        {
          path: 'SearchPlatform',
          name: 'SearchPlatform',
          component: () => import('@/views/cms/searchPlatform.vue')
        },
        {
          path: 'download',
          name: 'download',
          component: () => import('@/views/cms/download.vue')
        },
        {
          path: 'leaflet',
          name: 'leaflet',
          component: () => import('@/views/cms/leaflet.vue')
        }, {
          path: 'Realcases/:catId?',
          name: 'Realcases',
          component: () => import('@/views/cms/RealSystem.vue')
        }, {
          path: 'esgworldrecord2024',
          name: 'esgworldrecord2024',
          component: () => import('@/views/photo/NewphotoList.vue')
        }, {
          path: 'systems',
          name: 'systems',
          component: () => import('@/views/cms/Sys.vue')
        }, {
          path: 'ESG',
          name: 'ESG',
          component: () => import('@/views/cms/ESG.vue')
        },
        {
          path: 'esgEvents',
          name: 'esgEvents',
          component: () => import('@/views/cms/esgEvents.vue')
        },
        {
          path: 'Esg3on3',
          name: 'Esg3on3',
          component: () => import('@/views/cms/Esg3on3.vue')
        },

        {
          path: 'AIShow',
          name: 'AIShow',
          component: () => import('@/views/cms/AIShow.vue')
        }, {
          path: 'ESGMurderMystery',
          name: 'ESGMurderMystery',
          component: () => import('@/views/cms/ESGMurderMystery.vue')
        }, {
          path: 'flashLink',
          name: 'flashLink',
          component: () => import('@/views/cms/flashLink.vue')
        }, {
          path: 'Run',
          name: 'Run',
          component: () => import('@/components/business/cms/Run.vue')
        }, {
          path: 'Cherish',
          name: 'Cherish',
          component: () => import('@/views/cms/Cherish.vue')
        }
      ]
    },
    {
      path: '/building',
      name: 'building',
      component: () => import('@/views/building.vue')
    },
    {
      path: '/regnpay',
      component: RNPLayout,
      children: [{
        path: '',
        name: 'regnpay',
        component: () => import('@/views/regNPay/index.vue'),
        children: [{
          path: 'form/:id',
          name: 'regNPayForm',
          component: () => import('@/views/regNPay/regNPayForm.vue')
        }, {
          path: 'result/:id',
          name: 'regNPayResult',
          component: () => import('@/views/regNPay/regNPayResult.vue')
        }]
      }]
    },
    {
      path: '',
      component: VcardLayout,
      children: [{
        path: '/AntheaMak',
        name: 'AntheaMak',
        component: () => import('@/views/vcard/AntheaMak.vue')
      }, {
        path: '/CarolTse',
        name: 'CarolTse',
        component: () => import('@/views/vcard/CarolTse.vue')
      }, {
        path: '/Christy',
        name: 'Christy',
        component: () => import('@/views/vcard/Christy.vue')
      }, {
        path: '/daisy',
        name: 'daisy',
        component: () => import('@/views/vcard/daisy.vue')
      }, {
        path: '/Hoyee',
        name: 'Hoyee',
        component: () => import('@/views/vcard/Hoyee.vue')
      }, {
        path: '/IvanFok',
        name: 'IvanFok',
        component: () => import('@/views/vcard/IvanFok.vue')
      }, {
        path: '/Ivy',
        name: 'Ivy',
        component: () => import('@/views/vcard/Ivy.vue')
      }, {
        path: '/Kelvin',
        name: 'Kelvin',
        component: () => import('@/views/vcard/Kelvin.vue')
      }, {
        path: '/Kennis',
        name: 'Kennis',
        component: () => import('@/views/vcard/Kennis.vue')
      }, {
        path: '/Lily',
        name: 'Lily',
        component: () => import('@/views/vcard/Lily.vue')
      }, {
        path: '/Roslyn',
        name: 'Roslyn',
        component: () => import('@/views/vcard/Roslyn.vue')
      }, {
        path: '/Temmy',
        name: 'Temmy',
        component: () => import('@/views/vcard/Temmy.vue')
      }, {
        path: '/Nyx',
        name: 'Nyx',
        component: () => import('@/views/vcard/Nyx.vue')
      }, {
        path: '/Sofia',
        name: 'Sofia',
        component: () => import('@/views/vcard/Sofia.vue')
      }, {
        path: '/Tina',
        name: 'Tina',
        component: () => import('@/views/vcard/Tina.vue')
      }, {
        path: '/Wing',
        name: 'Wing',
        component: () => import('@/views/vcard/Wing.vue')
      },
      {
        path: '/BowieTse',
        name: 'BowieTse',
        component: () => import('@/views/vcard/BowieTse.vue')
      },
      {
        path: '/Kristin',
        name: 'Kristin',
        component: () => import('@/views/vcard/Kristin.vue')
      },
      {
        path: '/e-banner/:key',
        name: 'e-banner',
        component: () => import('@/components/business/flashlink/namecard.vue')
      },
      {
        path: '/HARAmanagementgroup/:key',
        name: 'HARAmanagementgroup',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/WilsonPropertymgt/Kensham',
        name: 'Kensham',
        component: () => import('@/components/business/flashlink/Kensham.vue')
      },
      {
        path: '/WilsonPropertymgt/Peter',
        name: 'Peter',
        component: () => import('@/components/business/flashlink/Petershum.vue')
      },
      {
        path: '/KINOX/Eric',
        name: 'Eric',
        component: () => import('@/components/business/flashlink/Eric.vue')
      },
      {
        path: '/wongwingwai/RayWong',
        name: 'RayWong',
        component: () => import('@/components/business/flashlink/RayWong.vue')
      },
      {
        path: '/CHINATEC/LeeKwokPong',
        name: 'LeeKwokPong',
        component: () => import('@/components/business/flashlink/LeeKwokPong.vue')
      },
      {
        path: '/SeedMaster/Willis',
        name: 'Willis',
        component: () => import('@/components/business/flashlink/Willis.vue')
      },
      {
        path: '/ailoveyoumall/ailoveyou',
        name: 'ailoveyou',
        component: () => import('@/components/business/flashlink/ailoveyou.vue')
      },
      {
        path: '/CRLongdation/Vincent',
        name: 'CRLongdationVincent',
        component: () => import('@/components/business/flashlink/CRLongdationVincent.vue')
      },
      {
        path: '/longcaring/Vincent',
        name: 'longcaringVincent',
        component: () => import('@/components/business/flashlink/longcaringVincent.vue')
      },
      {
        path: '/Yicktat/EdwardYu',
        name: 'EdwardYu',
        component: () => import('@/components/business/flashlink/EdwardYu.vue')
      },
      {
        path: '/HENDERSONLAND/idachan',
        name: 'idachan',
        component: () => import('@/components/business/flashlink/idachan.vue')
      },
      {
        path: '/NOVA/Rebecca',
        name: 'Rebecca',
        component: () => import('@/components/business/flashlink/Rebecca.vue')
      },
      {
        path: '/KarinGroup/Juni',
        name: 'Juni',
        component: () => import('@/components/business/flashlink/Juni.vue')
      },
      {
        path: '/HKJewelry/Tris',
        name: 'Tris',
        component: () => import('@/components/business/flashlink/Tris.vue')
      },
      {
        path: '/Tencent/James',
        name: 'James',
        component: () => import('@/components/business/flashlink/James.vue')
      },
      {
        path: '/Tencent/Patrickchan',
        name: 'Patrickchan',
        component: () => import('@/components/business/flashlink/Patrickchan.vue')
      },
      {
        path: '/Birentech/Jamie',
        name: 'Jamie',
        component: () => import('@/components/business/flashlink/Jamie.vue')
      },
      {
        path: '/EVision/Sherman',
        name: 'Jamie',
        component: () => import('@/components/business/flashlink/Sherman.vue')
      },
      {
        path: '/blil/Peterlam',
        name: 'Jamie',
        component: () => import('@/components/business/flashlink/Peterlam.vue')
      },
      {
        path: '/Gammonconstruction/:key',
        name: 'Gammonconstruction',
        component: () => import('@/components/business/Gammonconstruction/vcard.vue')
      },
      {
        path: '/Zoeface/:key',
        name: 'Zoeface',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/HKAIIA/:key',
        name: 'HKAIIA',
        component: () => import('@/components/business/flashlink/namecardB.vue')
      }, {
        path: '/FullMoon/:key',
        name: 'FullMoon',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/FanCFu',
        name: '/FanCFu',
        component: () => import('@/components/business/flashlink/FanCFu.vue')
      }, {
        path: '/Brian',
        name: 'Brian',
        component: () => import('@/components/business/flashlink/Brian.vue')
      }, {
        path: '/Ting',
        name: 'Ting',
        component: () => import('@/components/business/flashlink/Ting.vue')
      }, {
        path: '/George',
        name: 'George',
        component: () => import('@/components/business/flashlink/George.vue')
      }, {
        path: '/twinslink/:key',
        name: 'twinslink',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/fashionbeautyhk/:key',
        name: 'fashionbeautyhk',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/PrbyAi/:key',
        name: 'PrbyAi',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/ShineResourcesLimited/:key',
        name: 'ShineResourcesLimited',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/4466/:key',
        name: '4466',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/Pollyclean/:key',
        name: 'Pollyclean',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/FlowerworksFleuristeCo/:key',
        name: 'FlowerworksFleuristeCo',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/ClassicTrading/:key',
        name: 'ClassicTrading',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/inmost/:key',
        name: 'inmost',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/Metaprint/:key',
        name: 'Metaprint',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/Truststech/:key',
        name: 'Truststech',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/Shunshing/:key',
        name: 'Shunshing',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/Talentcare/:key',
        name: 'Talentcare',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/gdnatural/:key',
        name: 'gdnatural',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/Hikeupservice/:key',
        name: 'Hikeupservice',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/QQNest/:key',
        name: 'QQNest',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/Cyberport/:key',
        name: 'Cyberport',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/TVB/:key',
        name: 'TVB',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/AlcomAsia/:key',
        name: 'AlcomAsia',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/Tungwah/MichelleAU',
        name: 'Tungwah',
        component: () => import('@/components/business/flashlinkV2/MichelleAU.vue')
      }, {
        path: '/Tungwah/lesleymak',
        name: 'Tungwah',
        component: () => import('@/components/business/flashlinkV2/lesleymak.vue')
      }, {
        path: '/METTAW/LadyFucius',
        name: 'METTAW',
        component: () => import('@/components/business/flashlinkV2/LadyFucius.vue')
      }, {
        path: '/TAIWAMKITCHEN/ManchunKei',
        name: 'ManchunKei',
        component: () => import('@/components/business/flashlinkV2/ManchunKei.vue')
      }, {
        path: '/TAIWAMKITCHEN/AndyChan',
        name: 'AndyChan',
        component: () => import('@/components/business/flashlinkV2/AndyChan.vue')
      }, {
        path: '/TAIWAMKITCHEN/HoKaHo',
        name: 'HoKaHo',
        component: () => import('@/components/business/flashlinkV2/HoKaHo.vue')
      }, {
        path: '/TAIWAMKITCHEN/Keishunkiu',
        name: 'Keishunkiu',
        component: () => import('@/components/business/flashlinkV2/Keishunkiu.vue')
      }, {
        path: '/TAIWAMKITCHEN/Liukwanlam',
        name: 'Liukwanlam',
        component: () => import('@/components/business/flashlinkV2/Liukwanlam.vue')
      }, {
        path: '/Talentpool/PeggyLee',
        name: 'Talentpool',
        component: () => import('@/components/business/flashlinkV2/PeggyLee.vue')
      }, {
        path: '/JamieChan',
        name: 'JamieChan',
        component: () => import('@/components/business/flashlinkV2/JamieChan.vue')
      }, {
        path: '/HKGX/:key',
        name: 'HKGX',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/Talentpool/:key',
        name: 'Talentpool',
        component: () => import('@/components/business/flashlink/namecard.vue')
      }, {
        path: '/HKCIVICASSOCIATION/Lam',
        name: 'HKCIVICASSOCIATION',
        component: () => import('@/components/business/flashlink/Lam.vue')
      }, {
        path: '/PMSA/JamesWong',
        name: 'PMSA',
        component: () => import('@/components/business/flashlink/JamesWong.vue')
      }, {
        path: '/SaiKungDistrictCouncil/Victor',
        name: 'SaiKungDistrictCouncil',
        component: () => import('@/components/business/flashlink/Victor.vue')
      }, {
        path: '/TaiWoTung/Ray',
        name: 'TaiWoTung',
        component: () => import('@/components/business/flashlink/Ray.vue')
      }, {
        path: '/NPP/Alvin',
        name: 'NPP',
        component: () => import('@/components/business/flashlink/Alvin.vue')
      }, {
        path: '/hkinnovision/AlbertYip',
        name: 'hkinnovision',
        component: () => import('@/components/business/flashlink/AlbertYip.vue')
      }, {
        path: '/TamJai/Derek',
        name: 'TamJai',
        component: () => import('@/components/business/flashlink/Derek.vue')
      }, {
        path: '/COP/Joseph',
        name: 'COP',
        component: () => import('@/components/business/flashlink/Joseph.vue')
      }]
    },
    {
      path: '',
      component: gdnaturalLayout,
      children: [{
        path: 'goodnatural/index',
        name: 'goodnatural',
        component: () => import('@/components/business/gdnatural/index.vue')
      }
      ]
    },
    {
      path: '/payment',
      component: RNPLayout,
      children: [{
        path: 'PaySuccess/:id',
        name: 'PaySuccess',
        component: () => import('@/views/payment/paySuccess.vue')
      }, {
        path: 'PayFail/:id',
        name: 'PayFail',
        component: () => import('@/views/payment/payFail.vue')
      }]
    },
    // {
    //   path: '/cms/SearchPlatform',
    //   component: searchPlatform,
    //   children: [{
    //     path: 'SearchPlatform',
    //     name: 'SearchPlatform',
    //     component: () => import('@/views/cms/searchPlatform.vue')
    //   }]
    // },
    {
      path: '/cms',
      component: Layout,
      children: [{
        path: 'content/:id',
        name: 'cmsContent',
        component: () => import('@/views/cms/content.vue')
      },
      {
        path: 'normal/:id',
        name: 'normal',
        component: () => import('@/views/cms/normal.vue')
      },
      {
        path: 'vr/:id',
        name: 'vr',
        component: () => import('@/views/cms/vr.vue')
      },
      {
        path: 'songdirection/:id',
        name: 'vr',
        component: () => import('@/views/cms/songdirection.vue')
      },
      {
        path: 'catDetail/:id',
        name: 'cmsCatDetail',
        component: () => import('@/views/cms/catDetail.vue')
      }, {
        path: 'payme',
        name: 'payme',
        component: () => import('@/views/cms/payme.vue')
      },
      {
        path: 'paypal',
        name: 'paypal',
        component: () => import('@/views/cms/paypal.vue')
      },
      {
        path: 'paymentAsia',
        name: 'paymentAsia',
        component: () => import('@/views/cms/paymentAsia.vue')
      },
      {
        path: 'contentNew/:id',
        name: 'contentNew',
        component: () => import('@/views/cms/contentN.vue')
      },
      {
        path: 'songDetail/:id',
        name: 'songDetail',
        component: () => import('@/views/cms/songDetail.vue')
      },
      {
        path: 'search/:key',
        name: 'search',
        component: () => import('@/views/cms/search.vue')
      }, {
        path: 'emf',
        name: 'emf',
        component: () => import('@/views/cms/emf.vue')
      }, {
        path: 'tvp',
        name: 'tvp',
        component: () => import('@/views/cms/tvp.vue')
      }, {
        path: 'bud',
        name: 'bud',
        component: () => import('@/views/cms/bud.vue')
      }, {
        path: 'easybud',
        name: 'easybud',
        component: () => import('@/views/cms/easybud.vue')
      }, {
        path: 'digital',
        name: 'digital',
        component: () => import('@/views/cms/digital.vue')
      }, {
        path: 'Nifs',
        name: 'Nifs',
        component: () => import('@/views/cms/Nifs.vue')
      }, {
        path: 'ECommerceEasy',
        name: 'ECommerceEasy',
        component: () => import('@/views/cms/ECommerceEasy.vue')
      }, {
        path: 'CustomerReview/:id',
        name: 'CustomerReview',
        component: () => import('@/views/cms/CustomerReview.vue')
      }, {
        path: 'Intern',
        name: 'Intern',
        component: () => import('@/views/cms/Intern.vue')
      }, {
        path: 'AuditChill',
        name: 'AuditChill',
        component: () => import('@/views/cms/AuditChill.vue')
      },
      {
        path: 'DigitalMarketing',
        name: 'DigitalMarketing',
        component: () => import('@/views/cms/DigitalMarketing.vue')
      },
      {
        path: 'DigitalTransformation',
        name: 'DigitalTransformation',
        component: () => import('@/views/cms/DigitalTransformation.vue')
      },
      {
        path: 'GovernmentFunding',
        name: 'GovernmentFunding',
        component: () => import('@/views/cms/GovernmentFunding.vue')
      },
      {
        path: 'SLA',
        name: 'SLA',
        component: () => import('@/views/cms/SLA.vue')
      },
      {
        path: 'Advertising',
        name: 'Advertising',
        component: () => import('@/views/cms/Advertising.vue')
      },
      {
        path: 'NetLearnPlus',
        name: 'NetLearnPlus',
        component: () => import('@/views/cms/NetLearnPlus.vue')
      }, {
        path: 'gsp',
        name: 'gsp',
        component: () => import('@/views/cms/gsp.vue')
      },
      {
        path: 'Nias',
        name: 'Nias',
        component: () => import('@/views/cms/Nias.vue')
      }, {
        path: 'budAi',
        name: 'budAi',
        component: () => import('@/views/cms/budAi.vue')
      }
      ]
    },
    {
      path: '/event',
      component: Layout,
      children: [{
        path: 'list/:date',
        name: 'eventList',
        component: () => import('@/views/event/eventList.vue')
      }, {
        path: 'detail/:id',
        name: 'eventDetail',
        component: () => import('@/views/event/eventDetail.vue')
      }]
    },
    {
      path: '/photo',
      component: Layout,
      children: [{
        path: 'album',
        name: 'photoAlbum',
        component: () => import('@/views/photo/photoAlbum.vue')
      },
      {
        path: 'list/:id',
        name: 'photoList',
        component: () => import('@/views/photo/photoListN.vue')
      }]
    },
    {
      path: '/account',
      component: Layout,
      children: [{
        path: 'login',
        name: 'login',
        component: () => import('@/components/business/account/InsLoginN.vue')
      },
      {
        path: 'Register',
        name: 'Register',
        component: () => import('@/components/business/account/InsRegister.vue')
      },
      {
        path: 'RegisterSuccess',
        name: 'RegisterSuccess',
        component: () => import('@/components/business/account/Reg/InsRegSuccess.vue')
      },
      {
        path: 'forgetPassword',
        name: 'forgetPassword',
        component: () => import('@/components/business/account/InsForgetPassword.vue')
      },
      {
        path: 'ModifyPassword',
        name: 'ModifyPassword',
        meta: {
          requiresAuth: true // 是否进行登录验证
        },
        component: () => import('@/components/business/account/InsModifyPassword.vue')
      },
      {
        path: 'memberInfo',
        name: 'memberInfo',
        meta: {
          requiresAuth: true // 是否进行登录验证
        },
        component: () => import('@/components/business/account/InsMemberInfo.vue')
      },
      {
        path: 'ResetPwd/:id/:code',
        name: 'notification',
        component: () => import('@/components/business/account/InsResetPwd.vue')
      },
      {
        path: '/account/notification',
        name: 'notification',
        meta: {
          requiresAuth: true // 是否进行登录验证
        },
        component: () =>
          import(
            /* webpackChunkName: "account" */ '@/components/business/account/InsNotification.vue'
          )
      },
      ]
    },
  ]
});

export default router;
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) { // 如果未匹配到路由
    // SEO判斷處理
    let lang = to.path.toLowerCase().match(/\/en|\/xc|\/tc/i);

    if (lang) {
      let transLang;
      switch (lang[0]) {
        case '/en':
          transLang = 'E';
          break;
        case '/xc':
          transLang = 'S';
          break;
        case '/tc':
          transLang = 'C';
          break;
      }

      i18n.locale = transLang;

      next({
        path: to.path.toLowerCase().replace(lang[0], '')
      });
    } else {
      from.name ? next({ name: from.name }) : next('/'); // 如果上級也未匹配到路由則跳轉首頁，如果上級能匹配到則轉上級路由
    }
  }


  // 標記是從列表頁跳轉產品詳情頁的，方便返回時判斷
  if (from.name) {
    Vue.prototype.$ShowLayer();
    setTimeout(() => {
      Vue.prototype.$HiddenLayer();
    }, 500);
  }
  setTimeout(function () {
    if (to.path === '/account/login') {
      if (storage.get('isLogin')) {
        next({ path: '/home' });
      }
      next();
    } else {
      if (to.matched.length === 0) {
        next('/'); // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到首页
      }
      next(); // 如果匹配到正确跳转
      if (to.matched.some(record => record.meta.requiresAuth) && !storage.get('isLogin')) {
        // router.push({ path: '/account/login' });
        next({
          path: '/account/login',
          query: {
            returnurl: to.path
          }
        });
      } else if (to.matched.some(record => record.meta.requiresAuth) && storage.get('timeout') && storage.get('timeout') < new Date().getTime()) {
        Vue.prototype.$Login(function () { next(); });
      } else {
        next();
      }
    }
  }, 200);
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.onlyFrom)) {
    if ((to as any).meta.onlyFrom === from.path) next();
    else next((to as any).meta.onlyFrom);
  } else {
    next();
  }
});
